<template>
  <section class="container mb-5 event-registration-wrapper">
    <div class="row">
      <div class="col-md-7 col-lg-8 event-right-container order-1 order-md-0">
        <el-skeleton :rows="6" animated v-if="pageStatus === 'loading'"/>
        <already-registered v-else-if="pageStatus === 'already-registered'" :user="duplicateParticipant"
                            :labels="eventConfig"/>
        <sold-out v-else-if="pageStatus === 'sold-out'"/>
        <el-empty :image-size="200" v-else-if="eventConfig && eventConfig['oneclick-required'] && !donationDetail"
                  description="This event is by invitation only. Please contact events@nsw.liberal.org.au for further details."/>


        <el-empty :image-size="200" v-else-if="['not-found', 'error', 'invalid-ck-id'].includes(pageStatus)"
                  description="Event not found"></el-empty>
        <el-empty :image-size="200" v-else-if="isEventLocked"
                  description="This event is by invitation only. Please contact events@nsw.liberal.org.au for further details."></el-empty>

        <template v-else>
          <ticket-selection
              v-if="step === 1"
              :labels="eventConfig"
              :donationConfig="donationConfig"
              :item="eventDetail"
              :tickets="tickets"
              @next-step="onNextStep"
          />
          <participant
              v-if="step === 2"
              :tickets="tickets"
              :eventDetail="eventDetail"
              :donationDetail="donationDetail"
              :eventConfig="eventConfig"
              :donationConfig="donationConfig"
              :participants="participants"
              @next-step="onNextStep"/>
          <billing-info
              v-if="step === 3"
              :tickets="tickets"
              :eventConfig="eventConfig"
              :billingInfo="billingInfo"
              :donationDetail="donationDetail"
              :participants="participants"
              @next-step="onNextStep"/>
          <payment
              v-if="step === 4"
              :tickets="tickets"
              :billingInfo="billingInfo"
              :eventConfig="eventConfig"
              :participants="participants"
              :userRoles="userRoles"
              @next-step="onNextStep"/>

          <thank-you
              v-if="step === 5"
              :eventConfig="eventConfig"
              :receipt="receipt"
              :tickets="tickets"
              :participants="participants"/>


          <free-payment
              v-if="step === 6"
              :tickets="tickets"
              :billingInfo="billingInfo"
              :eventConfig="eventConfig"
              :participants="participants"
              :userRoles="userRoles"
              @next-step="onNextStep"/>

        </template>
      </div><!-- /.col-md-8 -->
      <div class="col-md-5 col-lg-4 event-left-container order-0 order-md-1" v-if="!isEventLocked">
        <el-skeleton :rows="10" animated v-if="pageStatus === 'loading'"/>
        <event-detail-info v-else :status="pageStatus" :item="eventDetail"/>
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </section><!-- /.container -->
</template>

<script>
import {mapState, mapActions, mapMutations} from "vuex";
// import qs/*, { parse }*/ from 'query-string';

import EventDetailInfo from '../../components/FormEvent/EventDetail.vue';
import AlreadyRegistered from '../../components/FormEvent/AlreadyRegistered.vue';
import SoldOut from '../../components/FormEvent/SoldOut.vue';
import TicketSelection from '../../components/FormEvent/TicketSelection.vue';
import Participant from '../../components/FormEvent/Participant.vue';
import BillingInfo from '../../components/FormEvent/BillingInfo/Index.vue';
import Payment from '../../components/FormEvent/Payment/Index.vue';
import FreePayment from '../../components/FormEvent/Payment/Free.vue';
import ThankYou from '../../components/FormEvent/ThankYou.vue';

export default {
  components: {
    EventDetailInfo,
    AlreadyRegistered,
    SoldOut,
    TicketSelection,
    Participant,
    BillingInfo,
    Payment,
    FreePayment,
    ThankYou
  },
  mounted() {
    this.initData();
  },
  computed: {
    ...mapState({
      pageStatus: state => state.eventRegistration.status,
      step: state => state.eventRegistration.step,
      eventDetail: state => state.eventRegistration.eventDetail,
      donationDetail: state => state.eventRegistration.donationDetail,
      eventConfig: state => state.eventRegistration.eventConfig,
      donationConfig: state => state.eventRegistration.donationConfig,
      tickets: state => state.eventRegistration.tickets,
      participants: state => state.eventRegistration.participants,
      userRoles: state => state.eventRegistration.userRoles,
      donationRoles: state => state.eventRegistration.donationRoles,
      billingInfo: state => state.eventRegistration.billingInfo,
      receipt: state => state.eventRegistration.receipt,
      duplicateParticipant: state => state.eventRegistration.duplicateParticipant,

      // user: state => state.auth.user,
      bearerToken: state => state.auth.bearerToken,
      parsedUrlParams: state => state.auth.parsedUrlParams,
    }),

    isEventLocked: function () {
      // show locked if event is locked and user has no Financial role, or if oneClick is required and not settled
      if (this.eventConfig) {

        const hasFinancialRole = this?.donationRoles ? this.donationRoles.indexOf('Financial') > -1 : false;
        if (
            (this.pageStatus === 'success' && this.eventConfig['registration-locked'] && !hasFinancialRole)
            ||
            (this.eventConfig['oneclick-required'] && !this.donationDetail)
        )
        {
          return true;
        }
      }

      return false;
    }
  },
  methods: {
    ...mapMutations('eventRegistration', ['setStep', 'setTickets', 'setParticipants', 'setBillingInfo', 'setReceipt']),
    ...mapActions('eventRegistration', ['getInitialData', 'getDonationDetail']),
    ...mapActions('auth', ['initiateAuthAndSetEventUser']),

    async initData() {

      // if bearer token is not in the auth store, try setting it from the cookie (success will also store event user info)

      const eventUserSet = await this.initiateAuthAndSetEventUser()

      // todo: redirect to login or similar??
      if (!eventUserSet) {
        // return this.$router.push({ name: 'home' })
      }

      // get event user info from ck + id or stored token if available
      await this.getDonationDetail()

      /*
            // note are these values still used
            const unparsedParams = qs.parse(location.search);
            const parsed = {};

            for (const key in unparsedParams) {
              parsed[key.toLowerCase()] = unparsedParams[key]
            }
            */

      const eventCode = this.parsedUrlParams?.eventcode || ''

      // assign token from state as fallback (sets user role values for staff payment options)
      const token = this.parsedUrlParams?.token || this.bearerToken || ''

      const func = this.parsedUrlParams?.func || null

      await this.getInitialData({ /*id, ck, */eventCode, token, func})

    },
    onNextStep: function (payload) {
      this.setStep(payload.step);

      if (payload.tickets) {
        this.setTickets(payload.tickets);
      }

      if (payload.participants) {
        this.setParticipants(payload.participants);
      }

      if (payload.billingInfo) {
        this.setBillingInfo(payload.billingInfo);
      }

      if (payload.receiptInfo) {
        this.setReceipt(payload.receiptInfo);
      }

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
  }
}
</script>

<style>
@import './style.css';
</style>
